export default __webpack_public_path__ + "static/media/en.5ca914bc.svg";